<template>
  <div class="col-12 mb-2">
    <div class="observation mx-3">
      <div
        class="col-12 bg-secondary-1 py-2 rounded d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span class="fa-stack fa-1x">
            <i class="fas fa-circle fa-stack-2x color-green" />
            <i class="fas fa-search fa-stack-1x fa-inverse" />
          </span>
          <strong class="color-gray-7 ml-2">
            Observaciones
          </strong>
        </div>
        <div v-if="!readonly">
          <ActionButton
            v-if="observations.isExpanded"
            text="Cancelar"
            variant="outline-danger m-1 px-4"
            i="fas fa-times-circle"
            :responsive="false"
            @click="observations.isExpanded = false"
          />
          <ActionButton
            text="Añadir"
            variant="success m-1 px-4"
            i="fas fa-file-plus"
            :responsive="false"
            @click="onAdd()"
          />
        </div>
      </div>
      <div
        v-if="observations.isExpanded && !observations.disabled"
        class="col-12 bg-secondary-1 py-3 rounded mt-1"
      >
        <ValidationObserver ref="observations" slim>
          <ValidationProvider
            name="Observación / Razón"
            v-slot="{ errors }"
            rules="required"
          >
            <CustomTextArea
              v-model="observations.reason"
              :maxlength="3000"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
            <Error
              v-if="errors[0] && errors[0]"
              variant="no-border"
              message="Favor escriba una observación"
            />
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="col-12 bg-secondary-1 py-2 rounded mt-1">
        <div class="bg-white p-2 px-3 rounded">
          <time-line
            v-if="filteredItems && filteredItems.length"
            class="mt-4 col-11 mx-auto px-0"
          >
            <time-line-item
              v-for="(observation, index) in visibleItems"
              :key="index"
              class="custom-time-line rounded"
            >
              <div class="observation">
                <div class="row">
                  <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                    <label class="mb-0 color-gray-6 text-small">Rol:</label>
                    <span>{{ observation.rolName }}</span>
                  </div>
                  <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                    <label class="mb-0 color-gray-6 text-small">Usuario:</label>
                    <span>{{ observation.user }}</span>
                  </div>
                  <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                    <label class="mb-0 color-gray-6 text-small">Nombre:</label>
                    <span>{{ observation.userFullName }}</span>
                  </div>
                  <div class="col-12 col-md-3 flex-column d-flex mt-2">
                    <label class="mb-0 color-gray-6 text-small">Estatus:</label>
                    <span class="d-flex align-items-baseline">
                      <div
                        class="status-indicator"
                        :style="{
                          backgroundColor: observation?.historyStatus?.color,
                        }"
                      >
                        &nbsp;
                      </div>
                      <span>{{ observation?.historyStatus?.text }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <template #icon>
                <em
                  :class="`far fa-user-circle color-green fa-2x`"
                  class="radius"
                />
              </template>
              <template #date>
                <div class="date-container">
                  <div class="color-black font-14 font-weight-bold fulldate">
                    {{ formatDate(observation.date) }}
                    <small>{{ getTimeFromDate(observation.date) }}</small>
                  </div>
                </div>
              </template>
              <div id="comment-info" class="mt-3">
                <div class="info-panel bg-white rounded">
                  <div class="observation">
                    <div class="col">
                      <div class="info-panel-main-title">
                        <span class="color-gray-6 text-small">
                          Observación:
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="info-panel-container">
                    <div class="info-panel-item observation">
                      <div class="col-12 ">
                        <label>{{ observation.comment }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <ActionButton
                  v-if="canRemove"
                  variant="danger mt-3"
                  i="fa fa-times-circle"
                  @click="$emit('onObservationRemove', observation.id)"
                >
                  Eliminar
                </ActionButton>
              </div>
            </time-line-item>
          </time-line>
          <CustomResultNotFound v-else />
        </div>
      </div>
      <div class="col-12 mt-3 text-center">
        <action-button
          v-if="showCount < filteredItems.length"
          variant="outline-success custom-view-more m-1"
          i="fas fa-chevron-down"
          @click="showCount += limitNumber"
        >
          Ver más
        </action-button>

        <action-button
          v-if="showCount > limitNumber"
          variant="outline-danger custom-view-more m-1"
          i="fas fa-chevron-up"
          @click="showCount -= limitNumber"
        >
          Ver menos
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import Error from 'custom-error';
import CustomTextArea from 'CustomTextArea';
import { getObservations } from '@/components/pei/ubication-tech-assistance/_api';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import moment from 'moment';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'Observations',
  components: {
    ActionButton,
    Error,
    CustomTextArea,
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
  },
  props: {
    tabId: {
      type: [Number, String],
      default: null,
    },
    tapRequestId: {
      type: [Number, String],
      default: null,
    },
    sie: {
      type: [Number, String],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limitNumber: 2,
      showCount: 2,
      truncateLength: 300,
      observations: {
        disabled: false,
        isExpanded: false,
        reason: null,
      },
      model: [],
    };
  },
  computed: {
    filteredItems() {
      return this.model;
    },
    visibleItems() {
      return this.filteredItems.slice(0, this.showCount);
    },
  },

  async created() {
    await this.loadObservations();
  },

  methods: {
    async loadObservations() {
      if (this.tabId && this.tapRequestId) {
        const response = await getObservations(this.tapRequestId, this.tabId);
        if (response) {
          this.model = response.sort((a, b) => b.id - a.id);
        }
      }
    },
    goToObservation() {
      this.$router.push({
        name: 'uta-observations',
        params: {
          tapRequestId: this.tapRequestId,
          studentSIE: this.sie,
        },
      });
    },
    formatDate(value) {
      return `${moment(value).format('DD/MMM/YYYY')}`.toLowerCase();
    },
    getTimeFromDate(date) {
      return moment(date).format('hh:mm a');
    },
    loadMore() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    loadLess() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    formatComment(comment) {
      if (comment.length > this.truncateLength) {
        return comment.substring(0, this.truncateLength) + '...';
      } else {
        return comment;
      }
    },
    async onAdd() {
      if (this.observations.isExpanded) {
        const isValid = await this.$refs['observations'].validate();
        if (isValid) {
          this.$emit('onObservationAdded', this.observations.reason);
          this.$refs['observations'].reset();
          const maxId = Math.max(...this.model.map((o) => o.id), 0);
          const obj = { id: maxId + 1, comment: this.observations.reason };
          this.model.push(obj);
          this.model = this.model.sort((a, b) => b.id - a.id);

          this.observations.reason = null;
          this.observations.isExpanded = false;
        }
      } else {
        this.observations.isExpanded = true;
      }
    },
  },
};
</script>
<style scoped>
.text-small {
  font-size: 0.875rem;
}
.cursor-pointer {
  cursor: pointer;
}
.radius {
  width: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  background-color: transparent !important;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text-small {
  font-size: 0.875rem;
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.info-panel-container {
  overflow-wrap: anywhere;
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 1px 23px;
  .info-panel-item {
    flex: 1 0 25%;
    margin-bottom: 1.5em;
    float: left;
    box-sizing: border-box;
    padding-right: 10px;
    span {
      display: block;
      text-align: left;

      letter-spacing: 0px;
    }
    label {
      margin-top: 10px;
      text-align: left;
      font-size: 1rem;
      letter-spacing: 0px;

      line-height: 1.6em;
    }
  }
}
</style>
